import React, { FC, useEffect } from "react";

import { Modal } from "@/components/common";
import PaymentRequired from "./payment-required";
import ViewParcelServices from "./view-parcel-services";
import ViewParcelDetails from "./view-parcel-details";
import PaymentForm from "../../payment-form/payment-form";

import { useModal } from "@/hooks/useModal";

import { useParcels } from "@/context/Parcels.context";
import { unpaidParcelStatuses } from "@/utils/unpaidParcelStatuses";
import { useGetShipmentInvoiceRequest } from "@/api/useGetShipmentInvoiceRequest";
import { ICurrentShipment } from "@/types/apiResponse.types";

type TProps = {
  parcelId: number | null;
  currentParcel: ICurrentShipment | null;
};

const ViewGetParcel: FC<TProps> = ({ parcelId, currentParcel }) => {
  const { setParcelStatus } = useParcels();
  const { openModal, modalOpen, closeModal } = useModal();

  const { data: invoiceData } = useGetShipmentInvoiceRequest(parcelId);

  const invoiceFile = invoiceData?.data?.data?.invoiceFile || null;

  const parcelStatus = currentParcel?.commonStatus;

  const isParcelUnpaid =
    unpaidParcelStatuses.includes(parcelStatus) && !currentParcel?.isPaid;

  useEffect(() => {
    if (currentParcel) {
      setParcelStatus(parcelStatus);
    }
  }, [currentParcel]);

  return (
    <>
      <div className="w-[33.5rem] pb-10">
        {isParcelUnpaid && (
          <PaymentRequired
            totalPrice={currentParcel?.costUsd}
            openModal={openModal}
          />
        )}
        <ViewParcelDetails
          currentParcel={currentParcel}
          parcelStatus={parcelStatus}
          invoiceFile={invoiceFile}
        />
        <ViewParcelServices currentParcel={currentParcel} parcelId={parcelId} />
      </div>
      <Modal
        title="payments"
        isOpen={modalOpen}
        closeModal={closeModal}
        showCloseIcon
        paddings="!p-0"
      >
        <PaymentForm closeModal={closeModal} />
      </Modal>
    </>
  );
};

export default ViewGetParcel;
